/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASENavigation from "../../../@BASE/core/BASENavigation";
import clsx from "clsx";
import { memo, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectNavigation } from "../../store/BASE/navigationSlice";
import useThemeMediaQuery from "../../../@BASE/hooks/useThemeMediaQuery";
import { navbarCloseMobile } from "../../store/BASE/navbarSlice";

function Navigation(props) {
  const { className = '', layout = 'vertical', dense, active } = props;
  const navigation = useSelector(selectNavigation);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));

  const dispatch = useDispatch();

  return useMemo(() => {
    const handleItemClick = (item) => {
      if (isMobile) {
        dispatch(navbarCloseMobile());
      }
    };

    return (
      <BASENavigation
        className={clsx("navigation", className)}
        navigation={navigation}
        layout={layout}
        dense={dense}
        active={active}
        onItemClick={handleItemClick}
      />
    );
  }, [
    dispatch,
    isMobile,
    navigation,
    active,
    className,
    dense,
    layout,
  ]);
}

// Navigation.defaultProps = {
//   layout: "vertical",
// };

export default memo(Navigation);
